import { useCurrentClientIfAvailable } from 'src/clients/context/CurrentClientProvider';
import { useNavigate, useParams } from 'react-router';
import React from 'react';
import { FinancialItemDataDynamicForm } from 'src/financial/financial-data/financial-item/FinancialItemDataDynamicForm';
import { useContentMeta } from 'src/UI/app-container';
import { ChatMode } from 'src/UI/app-container/chat/types';
import { ClientListItem } from 'src/admin/users/types';
type Params = {
  product: string;
};

export default function CreateFinancialItemPage() {
  const { product } = useParams<Params>();
  const { client, clientId } = useCurrentClientIfAvailable();
  useContentMeta({ pageType: 'client', entityId: clientId, chatMode: ChatMode.CLIENT });

  if (product && client) {
    return <CreateFinancialItem product={product} client={client} />;
  }
}

type Props = {
  product: string;
  client: ClientListItem;
};

function CreateFinancialItem({ product, client }: Props) {
  const navigate = useNavigate();

  const handleSave = (id: string) => {
    navigate(`/client/${client.id}/financial-items/${product}/${id}`);
  };

  const backHref = `/client/${client.id}/financial-data/create`;

  return (
    <FinancialItemDataDynamicForm
      product={product}
      client={client}
      onSuccessfulSave={handleSave}
      backHref={backHref}
    />
  );
}
